/** Map MQTT reservation name */
export class AppReserved {
  public static RESERVED_DB_SCENARIO_CHANGED = "RESERVED_DB_SCENARIO_CHANGED";
  public static RESERVED_DB_SCHEDULATION_CHANGED =
    "RESERVED_DB_SCHEDULATION_CHANGED";
  public static RESERVED_DB_CALENDAR_CHANGED = "RESERVED_DB_CALENDAR_CHANGED";
  public static RESERVED_DB_NOTIFICATION_CHANGED =
    "RESERVED_DB_NOTIFICATION_CHANGED";
  public static RESERVED_DB_ENVIRONMENT_CHANGED =
    "RESERVED_DB_ENVIRONMENT_CHANGED";
  public static RESERVED_DB_LEVEL_PROTECTION_FUNCTION_CHANGED =
    "RESERVED_DB_LEVEL_PROTECTION_FUNCTION_CHANGED";
  public static RESERVED_DB_USERGROUP_CHANGED = "RESERVED_DB_USERGROUP_CHANGED";
  public static RESERVED_DB_USER_CHANGED = "RESERVED_DB_USER_CHANGED";
  public static RESERVED_DB_TIMESLOT_CHANGED = "RESERVED_DB_TIMESLOT_CHANGED";
  public static RESERVED_DB_DATAPROCESS_CHANGED =
    "RESERVED_DB_DATAPROCESS_CHANGED";
  public static RESERVED_DB_MAINTENANCE_CHANGED =
    "RESERVED_DB_MAINTENANCE_CHANGED";
  public static RESERVED_DB_DEVICE_CHANGED = "RESERVED_DB_DEVICE_CHANGED";
  public static RESERVED_DB_REPORT_CHANGED = "RESERVED_DB_REPORT_CHANGED";
  public static RESERVED_DB_EMERGENCY_LAMP_CHANGED =
    "RESERVED_DB_EMERGENCY_LAMP_CHANGED";
  public static RESERVED_DB_PAYMENT_CHANGED = "RESERVED_DB_PAYMENT_CHANGED";
  public static RESERVED_DB_CHART_CHANGED = "RESERVED_DB_CHART_CHANGED";
  public static RESERVED_DB_SCHEDULATION_SCENARIO_CHANGED =
    "RESERVED_DB_SCENARIO_SCHEDULATION_CHANGED";
  public static RESERVED_DB_SCHEDULATION_CALENDAR_CHANGED =
    "RESERVED_DB_SCHEDULATION_CALENDAR_CHANGED";
  public static RESERVED_DB_SCHEDULATION_NOTIFICATION_CHANGED =
    "RESERVED_DB_SCHEDULATION_NOTIFICATION_CHANGED";
  public static RESERVED_CUSTOM_INTERFACE_CHANGED =
    "RESERVED_CUSTOM_INTERFACE_CHANGED";
  public static RESERVED_CUSTOM_INTERFACE_DELETED =
    "RESERVED_CUSTOM_INTERFACE_DELETED";
  public static RESERVED_USER_PERMISSION_CHANGED =
    "RESERVED_USER_PERMISSION_CHANGED";
  //public static RESERVED_DB_ACCESSCONTROL_DATAUPDATED = "RESERVED_DB_ACCESSCONTROL_DATAUPDATED";
  public static RESERVED_DB_CARD_DATAUPDATED = "RESERVED_DB_CARD_DATAUPDATED";
  public static RESERVED_DB_CARDENVIRONMENT_DATAUPDATED =
    "RESERVED_DB_CARDENVIRONMENT_DATAUPDATED";
  public static RESERVED_DB_CUSTOMERSTAFF_DATAUPDATED =
    "RESERVED_DB_CUSTOMERSTAFF_DATAUPDATED";
  public static RESERVED_DB_RESERVATION_DATAUPDATED =
    "RESERVED_DB_RESERVATION_DATAUPDATED";
  public static RESERVED_DB_TIMESLOTID_DATAUPDATED =
    "RESERVED_DB_TIMESLOTID_DATAUPDATED";
  public static RESERVED_DB_BIGLOGICS_REFRESH = "RESERVED_DB_BIGLOGICS_REFRESH";
  public static RESERVED_DB_ACCESSCONTROL_FAILEDOPERATION_COUNT =
    "RESERVED_DB_ACCESSCONTROL_FAILEDOPERATION_COUNT";
  public static RESERVED_DB_WEEKLYPLANNING_CHANGED =
    "RESERVED_DB_WEEKLYPLANNING_CHANGED";
  public static RESERVED_DB_WEEKLYPLANNINGACTION_CHANGED =
    "RESERVED_DB_WEEKLYPLANNINGACTION_CHANGED";

  public static RESERVED_RELOAD_WEEKLY_PLANNING =
    "RESERVED_RELOAD_WEEKLY_PLANNING";

  public static RESERVED_DB_WEEKLYPLANNING_CALENDAR_CHANGED =
    "RESERVED_DB_WEEKLYPLANNING_CALENDAR_CHANGED";

  public static RESERVED_DB_REPORT_HTML_CHANGED =
    "RESERVED_DB_REPORT_HTML_CHANGED";
  public static RESERVED_DB_ACCOUNTING_ENTITIES_CHANGED =
    "RESERVED_DB_ACCOUNTING_ENTITIES_CHANGED";
  public static RESERVED_DB_CONTROL_GROUP_CHANGED =
    "RESERVED_DB_CONTROL_GROUP_CHANGED";
  public static RESERVED_RELOAD_LOAD_CONTROL = "RESERVED_RELOAD_LOAD_CONTROL";
  public static RESERVED_DB_CONTROL_CHANGED = "RESERVED_DB_CONTROL_CHANGED";
  public static RESERVED_DB_ADDRESSES_FORWARD_CHANGED =
    "RESERVED_DB_ADDRESSES_FORWARD_CHANGED";
  public static RESERVED_RELOAD_ADDRESSES_FORWARD =
    "RESERVED_RELOAD_ADDRESSES_FORWARD";
  public static RESERVED_DB_ACCESS_HISTORY_CHANGED =
    "RESERVED_DB_ACCESS_HISTORY_CHANGED";
  public static RESERVED_DB_PRESENCE_HISTORY_CHANGED =
    "RESERVED_DB_PRESENCE_HISTORY_CHANGED";
  public static RESERVED_DB_SMART_COMPONENT_CHANGED = "RESERVED_DB_SMART_COMPONENT_CHANGED";
  public static RESERVED_RELOAD_SMART_COMPONENT = "RESERVED_RELOAD_SMART_COMPONENT";

  public static RESERVED_RELOAD_TRANSLATION = "RESERVED_RELOAD_TRANSLATION";

  public static ADDRESS_LANGUAGE = "CurrentUser/Language";
  public static ADDRESS_ACK_NACK = "ACK_NACK";

  public static RESERVED_NOTIFICATION_REQUEST = "RESERVED_NOTIFICATION_REQUEST";
  public static RESERVED_ALARM_WORKINGOVER = "RESERVED_ALARM_WORKINGOVER";
  public static RESERVED_ALARM_SOLVED = "RESERVED_ALARM_SOLVED";
  public static RESERVED_ALARM_SOLVELATER = "RESERVED_ALARM_SOLVELATER";
  public static RESERVED_ALARM = "RESERVED_ALARM";
}
